import { StoreId, StoreInfo } from '../schemas';

export const CDE_MERCHANTS: Record<StoreId, StoreInfo> = {
  nissei: {
    id: 'nissei',
    name: 'Casa Nissei',
    displayName: 'Nissei',
    logoUrl: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=120&auto=format&fit=crop&q=80',
    domain: 'nissei.com',
    allowedDomains: ['nissei.com', 'www.nissei.com', 'compras.nissei.com'],
    shoppingMall: 'Shopping del Este / Monalisa',
    address: 'Av. Adrián Jara c/ Piribebuy, Ciudad del Este',
    floor: 'Planta Baja & 1er Piso',
    googleMapsUrl: 'https://maps.google.com/?q=Casa+Nissei+Ciudad+del+Este',
    rating: 4.9,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: true,
    verifiedPartner: true,
  },
  cellshop: {
    id: 'cellshop',
    name: 'Cellshop Importados',
    displayName: 'Cellshop',
    logoUrl: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=120&auto=format&fit=crop&q=80',
    domain: 'cellshop.com',
    allowedDomains: ['cellshop.com', 'www.cellshop.com', 'loja.cellshop.com'],
    shoppingMall: 'Shopping Ibiza',
    address: 'Av. Carlos Antonio López c/ Monseñor Rodriguez, Ciudad del Este',
    floor: 'Edificio Completo 5 Pisos',
    googleMapsUrl: 'https://maps.google.com/?q=Cellshop+Ciudad+del+Este',
    rating: 4.8,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 6,
    taxFreeAvailable: true,
    verifiedPartner: true,
  },
  mega_eletronicos: {
    id: 'mega_eletronicos',
    name: 'Mega Eletrônicos',
    displayName: 'Mega Eletrônicos',
    logoUrl: 'https://images.unsplash.com/photo-1526738549149-8e07eca6c147?w=120&auto=format&fit=crop&q=80',
    domain: 'megaeletronicos.com',
    allowedDomains: ['megaeletronicos.com', 'www.megaeletronicos.com'],
    shoppingMall: 'Shopping Jebai Center',
    address: 'Av. Monseñor Rodriguez c/ Regimiento Piribebuy',
    floor: 'Piso 2 y 3',
    googleMapsUrl: 'https://maps.google.com/?q=Mega+Eletronicos+Ciudad+del+Este',
    rating: 4.8,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  shopping_china: {
    id: 'shopping_china',
    name: 'Shopping China Importados',
    displayName: 'Shopping China',
    logoUrl: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=120&auto=format&fit=crop&q=80',
    domain: 'shoppingchina.com.py',
    allowedDomains: ['shoppingchina.com.py', 'www.shoppingchina.com.py'],
    shoppingMall: 'Shopping Paris',
    address: 'Av. Doctor Luis Maria Argaña, Ciudad del Este',
    floor: 'Piso 3 Completo (10.000 m²)',
    googleMapsUrl: 'https://maps.google.com/?q=Shopping+China+Ciudad+del+Este',
    rating: 4.9,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 7,
    taxFreeAvailable: true,
    verifiedPartner: true,
  },
  madrid_center: {
    id: 'madrid_center',
    name: 'Madrid Center',
    displayName: 'Madrid Center',
    logoUrl: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?w=120&auto=format&fit=crop&q=80',
    domain: 'madridcenter.com',
    allowedDomains: ['madridcenter.com', 'www.madridcenter.com'],
    shoppingMall: 'Galería San Blas',
    address: 'Av. San Blas c/ Curupayty',
    floor: 'Planta Baja',
    rating: 4.7,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  visovilar: {
    id: 'visovilar',
    name: 'Visovilar Home & Electronics',
    displayName: 'Visovilar',
    logoUrl: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=120&auto=format&fit=crop&q=80',
    domain: 'visovilar.com',
    allowedDomains: ['visovilar.com', 'www.visovilar.com'],
    shoppingMall: 'Shopping Vendôme',
    address: 'Av. Adrián Jara',
    rating: 4.6,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  mobile_zone: {
    id: 'mobile_zone',
    name: 'Mobile Zone International',
    displayName: 'Mobile Zone',
    logoUrl: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=120&auto=format&fit=crop&q=80',
    domain: 'mobilezone.com.py',
    allowedDomains: ['mobilezone.com.py', 'www.mobilezone.com.py'],
    shoppingMall: 'Shopping Jebai Center',
    address: 'Av. Monseñor Rodriguez',
    floor: 'Piso 1, Local 210',
    rating: 4.7,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 4.5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  atacado_games: {
    id: 'atacado_games',
    name: 'Atacado Games',
    displayName: 'Atacado Games',
    logoUrl: 'https://images.unsplash.com/photo-1612287233207-68b24522a1b9?w=120&auto=format&fit=crop&q=80',
    domain: 'atacadogames.com',
    allowedDomains: ['atacadogames.com', 'www.atacadogames.com'],
    shoppingMall: 'Galería Jebai Center',
    address: 'Av. Monseñor Rodriguez',
    floor: 'Piso 3',
    rating: 4.8,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  topdek: {
    id: 'topdek',
    name: 'Topdek Informática',
    displayName: 'Topdek',
    logoUrl: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=120&auto=format&fit=crop&q=80',
    domain: 'topdek.com.py',
    allowedDomains: ['topdek.com.py', 'www.topdek.com.py'],
    shoppingMall: 'Shopping Lai Lai Center',
    address: 'Av. Adrián Jara',
    rating: 4.7,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  elegancia_company: {
    id: 'elegancia_company',
    name: 'Elegancia Company Perfumería',
    displayName: 'Elegancia',
    logoUrl: 'https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?w=120&auto=format&fit=crop&q=80',
    domain: 'eleganciacompany.com.py',
    allowedDomains: ['eleganciacompany.com.py', 'www.eleganciacompany.com.py'],
    shoppingMall: 'Shopping del Este',
    address: 'Av. Monseñor Rodriguez',
    rating: 4.9,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: true,
    verifiedPartner: true,
  },
  oneclick: {
    id: 'oneclick',
    name: 'One Click Paraguay',
    displayName: 'One Click',
    logoUrl: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=120&auto=format&fit=crop&q=80',
    domain: 'oneclick.com.py',
    allowedDomains: ['oneclick.com.py', 'www.oneclick.com.py'],
    shoppingMall: 'Shopping Paris',
    address: 'Av. Doctor Luis Maria Argaña',
    rating: 4.8,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: true,
    verifiedPartner: true,
  },
  flytec: {
    id: 'flytec',
    name: 'Flytec Computers',
    displayName: 'Flytec',
    logoUrl: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=120&auto=format&fit=crop&q=80',
    domain: 'flyteccomputers.com',
    allowedDomains: ['flyteccomputers.com', 'www.flyteccomputers.com'],
    shoppingMall: 'Shopping Lai Lai Center',
    address: 'Av. Adrián Jara',
    rating: 4.7,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  multipass: {
    id: 'multipass',
    name: 'MultiPass Paraguay',
    displayName: 'MultiPass',
    logoUrl: 'https://images.unsplash.com/photo-1526738549149-8e07eca6c147?w=120&auto=format&fit=crop&q=80',
    domain: 'multipass.com.py',
    allowedDomains: ['multipass.com.py', 'www.multipass.com.py'],
    shoppingMall: 'Shopping del Este',
    address: 'Av. Monseñor Rodriguez',
    rating: 4.7,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  matrix: {
    id: 'matrix',
    name: 'Matrix Informática',
    displayName: 'Matrix',
    logoUrl: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?w=120&auto=format&fit=crop&q=80',
    domain: 'matrix.com.py',
    allowedDomains: ['matrix.com.py', 'www.matrix.com.py'],
    shoppingMall: 'Shopping Jebai Center',
    address: 'Av. Monseñor Rodriguez',
    rating: 4.7,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  digital_center: {
    id: 'digital_center',
    name: 'Digital Center CDE',
    displayName: 'Digital Center',
    logoUrl: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=120&auto=format&fit=crop&q=80',
    domain: 'digitalcenter.com.py',
    allowedDomains: ['digitalcenter.com.py', 'www.digitalcenter.com.py'],
    shoppingMall: 'Galería San Blas',
    address: 'Av. San Blas',
    rating: 4.6,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  nave: {
    id: 'nave',
    name: 'Nave Informática',
    displayName: 'Nave',
    logoUrl: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=120&auto=format&fit=crop&q=80',
    domain: 'naveinformatica.com',
    allowedDomains: ['naveinformatica.com', 'www.naveinformatica.com'],
    shoppingMall: 'Shopping Lai Lai Center',
    address: 'Av. Adrián Jara',
    rating: 4.7,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  ict: {
    id: 'ict',
    name: 'ICT Net Informática',
    displayName: 'ICT Net',
    logoUrl: 'https://images.unsplash.com/photo-1526738549149-8e07eca6c147?w=120&auto=format&fit=crop&q=80',
    domain: 'ictnet.com.py',
    allowedDomains: ['ictnet.com.py', 'www.ictnet.com.py'],
    shoppingMall: 'Shopping Jebai Center',
    address: 'Av. Monseñor Rodriguez',
    rating: 4.6,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  pioneer: {
    id: 'pioneer',
    name: 'Pioneer Internacional',
    displayName: 'Pioneer',
    logoUrl: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?w=120&auto=format&fit=crop&q=80',
    domain: 'pioneerinter.com',
    allowedDomains: ['pioneerinter.com', 'www.pioneerinter.com'],
    shoppingMall: 'Shopping Hijazi Center',
    address: 'Av. Adrián Jara',
    rating: 4.8,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
  audiovideo: {
    id: 'audiovideo',
    name: 'Audio & Video Paraguay',
    displayName: 'Audio & Video',
    logoUrl: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=120&auto=format&fit=crop&q=80',
    domain: 'audiovideo.com.py',
    allowedDomains: ['audiovideo.com.py', 'www.audiovideo.com.py'],
    shoppingMall: 'Shopping Vendôme',
    address: 'Av. Adrián Jara',
    rating: 4.7,
    acceptsPix: true,
    acceptsCards: true,
    acceptsCashUsd: true,
    acceptsCashArs: true,
    cardSurchargePercentage: 5,
    taxFreeAvailable: false,
    verifiedPartner: true,
  },
};

/**
 * Constructs direct store product/search URLs on the merchant's official e-commerce site.
 * GUARANTEE: Never points to comprasparaguai.com.br
 */
export function getDirectStoreProductUrl(storeId: string, productTitle: string, existingUrl?: string): string {
  if (
    existingUrl &&
    existingUrl.startsWith('https://') &&
    !existingUrl.includes('comprasparaguai.com.br') &&
    !existingUrl.includes('comprasparaguay')
  ) {
    return existingUrl;
  }

  const cleanTitle = productTitle.replace(/[^\w\s\d.-]/gi, ' ').replace(/\s+/g, ' ').trim();
  const encTitle = encodeURIComponent(cleanTitle);

  switch (storeId) {
    case 'nissei':
      return `https://nissei.com/py/catalogsearch/result/?q=${encTitle}`;
    case 'cellshop':
      return `https://cellshop.com/catalogsearch/result/?q=${encTitle}`;
    case 'shopping_china':
      return `https://www.shoppingchina.com.py/busca?q=${encTitle}`;
    case 'mega_eletronicos':
      return `https://www.megaeletronicos.com/busca?q=${encTitle}`;
    case 'madrid_center':
      return `https://www.madridcenter.com/busca?q=${encTitle}`;
    case 'atacado_games':
      return `https://www.atacadogames.com/busca?q=${encTitle}`;
    case 'mobile_zone':
      return `https://www.mobilezone.com.py/busca?q=${encTitle}`;
    case 'elegancia_company':
      return `https://www.eleganciacompany.com.py/catalogsearch/result/?q=${encTitle}`;
    case 'oneclick':
      return `https://oneclick.com.py/busca?q=${encTitle}`;
    case 'flytec':
      return `https://www.flyteccomputers.com/busca?q=${encTitle}`;
    case 'multipass':
      return `https://www.multipass.com.py/busca?q=${encTitle}`;
    case 'matrix':
      return `https://www.matrix.com.py/busca?q=${encTitle}`;
    case 'digital_center':
      return `https://www.digitalcenter.com.py/busca?q=${encTitle}`;
    case 'nave':
      return `https://www.naveinformatica.com/busca?q=${encTitle}`;
    case 'ict':
      return `https://www.ictnet.com.py/busca?q=${encTitle}`;
    case 'pioneer':
      return `https://www.pioneerinter.com/busca?q=${encTitle}`;
    case 'audiovideo':
      return `https://www.audiovideo.com.py/busca?q=${encTitle}`;
    case 'visovilar':
      return `https://www.visovilar.com/busca?q=${encTitle}`;
    case 'topdek':
      return `https://www.topdek.com.py/busca?q=${encTitle}`;
    default:
      return `https://nissei.com/py/catalogsearch/result/?q=${encTitle}`;
  }
}
